export default "__VITE_ASSET__CXmEF_Sr__"